/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SecurityLevelHierarchyResponse,
  SecurityLevelInitializationResponse,
  SecurityLevelValueResponse,
  TenantSecurityLevelCreateRequest,
  TenantSecurityLevelResponse,
  TenantSecurityLevelUpdateRequest,
} from '../models/index';
import {
    SecurityLevelHierarchyResponseFromJSON,
    SecurityLevelHierarchyResponseToJSON,
    SecurityLevelInitializationResponseFromJSON,
    SecurityLevelInitializationResponseToJSON,
    SecurityLevelValueResponseFromJSON,
    SecurityLevelValueResponseToJSON,
    TenantSecurityLevelCreateRequestFromJSON,
    TenantSecurityLevelCreateRequestToJSON,
    TenantSecurityLevelResponseFromJSON,
    TenantSecurityLevelResponseToJSON,
    TenantSecurityLevelUpdateRequestFromJSON,
    TenantSecurityLevelUpdateRequestToJSON,
} from '../models/index';

export interface CreateSecurityLevelRequest {
    tenantSecurityLevelCreateRequest: TenantSecurityLevelCreateRequest;
    sessionId?: string;
}

export interface DeleteSecurityLevelRequest {
    id: string;
    sessionId?: string;
}

export interface GetAllSecurityLevelsRequest {
    sessionId?: string;
    active?: boolean;
}

export interface GetMaxSecurityLevelRequest {
    sessionId?: string;
}

export interface GetMinSecurityLevelRequest {
    sessionId?: string;
}

export interface GetSecurityLevelRequest {
    id: string;
    sessionId?: string;
}

export interface InitializeDefaultSecurityLevelsRequest {
    sessionId?: string;
}

export interface UpdateSecurityLevelRequest {
    id: string;
    tenantSecurityLevelUpdateRequest: TenantSecurityLevelUpdateRequest;
    sessionId?: string;
}

export interface ValidateSecurityLevelHierarchyRequest {
    sessionId?: string;
}

/**
 * TenantSecurityLevelsApi - interface
 * 
 * @export
 * @interface TenantSecurityLevelsApiInterface
 */
export interface TenantSecurityLevelsApiInterface {
    /**
     * Creates a new security level for the current tenant with the specified name, display name, and level value.
     * @summary Create a new security level
     * @param {TenantSecurityLevelCreateRequest} tenantSecurityLevelCreateRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantSecurityLevelsApiInterface
     */
    createSecurityLevelRaw(requestParameters: CreateSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecurityLevelResponse>>;

    /**
     * Creates a new security level for the current tenant with the specified name, display name, and level value.
     * Create a new security level
     */
    createSecurityLevel(requestParameters: CreateSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSecurityLevelResponse>;

    /**
     * Soft deletes a security level by setting it as inactive. The level is not permanently removed.
     * @summary Delete security level
     * @param {string} id Security level ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantSecurityLevelsApiInterface
     */
    deleteSecurityLevelRaw(requestParameters: DeleteSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecurityLevelResponse>>;

    /**
     * Soft deletes a security level by setting it as inactive. The level is not permanently removed.
     * Delete security level
     */
    deleteSecurityLevel(requestParameters: DeleteSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSecurityLevelResponse>;

    /**
     * Retrieves all security levels for the current tenant, optionally filtered by active status.
     * @summary Get all security levels
     * @param {string} [sessionId] Session ID for authorization
     * @param {boolean} [active] Filter by active status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantSecurityLevelsApiInterface
     */
    getAllSecurityLevelsRaw(requestParameters: GetAllSecurityLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecurityLevelResponse>>;

    /**
     * Retrieves all security levels for the current tenant, optionally filtered by active status.
     * Get all security levels
     */
    getAllSecurityLevels(requestParameters: GetAllSecurityLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSecurityLevelResponse>;

    /**
     * Retrieves the maximum security level value for the current tenant.
     * @summary Get maximum security level
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantSecurityLevelsApiInterface
     */
    getMaxSecurityLevelRaw(requestParameters: GetMaxSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLevelValueResponse>>;

    /**
     * Retrieves the maximum security level value for the current tenant.
     * Get maximum security level
     */
    getMaxSecurityLevel(requestParameters: GetMaxSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLevelValueResponse>;

    /**
     * Retrieves the minimum security level value for the current tenant.
     * @summary Get minimum security level
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantSecurityLevelsApiInterface
     */
    getMinSecurityLevelRaw(requestParameters: GetMinSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLevelValueResponse>>;

    /**
     * Retrieves the minimum security level value for the current tenant.
     * Get minimum security level
     */
    getMinSecurityLevel(requestParameters: GetMinSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLevelValueResponse>;

    /**
     * Retrieves a specific security level by its ID for the current tenant.
     * @summary Get security level by ID
     * @param {string} id Security level ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantSecurityLevelsApiInterface
     */
    getSecurityLevelRaw(requestParameters: GetSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecurityLevelResponse>>;

    /**
     * Retrieves a specific security level by its ID for the current tenant.
     * Get security level by ID
     */
    getSecurityLevel(requestParameters: GetSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSecurityLevelResponse>;

    /**
     * Creates default security levels (PUBLIC, INTERNAL, CONFIDENTIAL, SECRET, TOP_SECRET) for the current tenant if none exist.
     * @summary Initialize default security levels
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantSecurityLevelsApiInterface
     */
    initializeDefaultSecurityLevelsRaw(requestParameters: InitializeDefaultSecurityLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLevelInitializationResponse>>;

    /**
     * Creates default security levels (PUBLIC, INTERNAL, CONFIDENTIAL, SECRET, TOP_SECRET) for the current tenant if none exist.
     * Initialize default security levels
     */
    initializeDefaultSecurityLevels(requestParameters: InitializeDefaultSecurityLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLevelInitializationResponse>;

    /**
     * Updates an existing security level with new display name, level value, or active status.
     * @summary Update security level
     * @param {string} id Security level ID
     * @param {TenantSecurityLevelUpdateRequest} tenantSecurityLevelUpdateRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantSecurityLevelsApiInterface
     */
    updateSecurityLevelRaw(requestParameters: UpdateSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecurityLevelResponse>>;

    /**
     * Updates an existing security level with new display name, level value, or active status.
     * Update security level
     */
    updateSecurityLevel(requestParameters: UpdateSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSecurityLevelResponse>;

    /**
     * Validates that the security level hierarchy is complete without gaps for the current tenant.
     * @summary Validate security level hierarchy
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantSecurityLevelsApiInterface
     */
    validateSecurityLevelHierarchyRaw(requestParameters: ValidateSecurityLevelHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLevelHierarchyResponse>>;

    /**
     * Validates that the security level hierarchy is complete without gaps for the current tenant.
     * Validate security level hierarchy
     */
    validateSecurityLevelHierarchy(requestParameters: ValidateSecurityLevelHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLevelHierarchyResponse>;

}

/**
 * 
 */
export class TenantSecurityLevelsApi extends runtime.BaseAPI implements TenantSecurityLevelsApiInterface {

    /**
     * Creates a new security level for the current tenant with the specified name, display name, and level value.
     * Create a new security level
     */
    async createSecurityLevelRaw(requestParameters: CreateSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecurityLevelResponse>> {
        if (requestParameters['tenantSecurityLevelCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'tenantSecurityLevelCreateRequest',
                'Required parameter "tenantSecurityLevelCreateRequest" was null or undefined when calling createSecurityLevel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-security-levels`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TenantSecurityLevelCreateRequestToJSON(requestParameters['tenantSecurityLevelCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantSecurityLevelResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new security level for the current tenant with the specified name, display name, and level value.
     * Create a new security level
     */
    async createSecurityLevel(requestParameters: CreateSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSecurityLevelResponse> {
        const response = await this.createSecurityLevelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft deletes a security level by setting it as inactive. The level is not permanently removed.
     * Delete security level
     */
    async deleteSecurityLevelRaw(requestParameters: DeleteSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecurityLevelResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSecurityLevel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-security-levels/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantSecurityLevelResponseFromJSON(jsonValue));
    }

    /**
     * Soft deletes a security level by setting it as inactive. The level is not permanently removed.
     * Delete security level
     */
    async deleteSecurityLevel(requestParameters: DeleteSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSecurityLevelResponse> {
        const response = await this.deleteSecurityLevelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all security levels for the current tenant, optionally filtered by active status.
     * Get all security levels
     */
    async getAllSecurityLevelsRaw(requestParameters: GetAllSecurityLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecurityLevelResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-security-levels`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantSecurityLevelResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all security levels for the current tenant, optionally filtered by active status.
     * Get all security levels
     */
    async getAllSecurityLevels(requestParameters: GetAllSecurityLevelsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSecurityLevelResponse> {
        const response = await this.getAllSecurityLevelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the maximum security level value for the current tenant.
     * Get maximum security level
     */
    async getMaxSecurityLevelRaw(requestParameters: GetMaxSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLevelValueResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-security-levels/max-level`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLevelValueResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the maximum security level value for the current tenant.
     * Get maximum security level
     */
    async getMaxSecurityLevel(requestParameters: GetMaxSecurityLevelRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLevelValueResponse> {
        const response = await this.getMaxSecurityLevelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the minimum security level value for the current tenant.
     * Get minimum security level
     */
    async getMinSecurityLevelRaw(requestParameters: GetMinSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLevelValueResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-security-levels/min-level`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLevelValueResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the minimum security level value for the current tenant.
     * Get minimum security level
     */
    async getMinSecurityLevel(requestParameters: GetMinSecurityLevelRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLevelValueResponse> {
        const response = await this.getMinSecurityLevelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific security level by its ID for the current tenant.
     * Get security level by ID
     */
    async getSecurityLevelRaw(requestParameters: GetSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecurityLevelResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSecurityLevel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-security-levels/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantSecurityLevelResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific security level by its ID for the current tenant.
     * Get security level by ID
     */
    async getSecurityLevel(requestParameters: GetSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSecurityLevelResponse> {
        const response = await this.getSecurityLevelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates default security levels (PUBLIC, INTERNAL, CONFIDENTIAL, SECRET, TOP_SECRET) for the current tenant if none exist.
     * Initialize default security levels
     */
    async initializeDefaultSecurityLevelsRaw(requestParameters: InitializeDefaultSecurityLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLevelInitializationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-security-levels/initialize-defaults`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLevelInitializationResponseFromJSON(jsonValue));
    }

    /**
     * Creates default security levels (PUBLIC, INTERNAL, CONFIDENTIAL, SECRET, TOP_SECRET) for the current tenant if none exist.
     * Initialize default security levels
     */
    async initializeDefaultSecurityLevels(requestParameters: InitializeDefaultSecurityLevelsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLevelInitializationResponse> {
        const response = await this.initializeDefaultSecurityLevelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing security level with new display name, level value, or active status.
     * Update security level
     */
    async updateSecurityLevelRaw(requestParameters: UpdateSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecurityLevelResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSecurityLevel().'
            );
        }

        if (requestParameters['tenantSecurityLevelUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'tenantSecurityLevelUpdateRequest',
                'Required parameter "tenantSecurityLevelUpdateRequest" was null or undefined when calling updateSecurityLevel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-security-levels/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TenantSecurityLevelUpdateRequestToJSON(requestParameters['tenantSecurityLevelUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantSecurityLevelResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing security level with new display name, level value, or active status.
     * Update security level
     */
    async updateSecurityLevel(requestParameters: UpdateSecurityLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSecurityLevelResponse> {
        const response = await this.updateSecurityLevelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates that the security level hierarchy is complete without gaps for the current tenant.
     * Validate security level hierarchy
     */
    async validateSecurityLevelHierarchyRaw(requestParameters: ValidateSecurityLevelHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLevelHierarchyResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-security-levels/validate-hierarchy`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLevelHierarchyResponseFromJSON(jsonValue));
    }

    /**
     * Validates that the security level hierarchy is complete without gaps for the current tenant.
     * Validate security level hierarchy
     */
    async validateSecurityLevelHierarchy(requestParameters: ValidateSecurityLevelHierarchyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLevelHierarchyResponse> {
        const response = await this.validateSecurityLevelHierarchyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
